import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { bemClassBuilder } from '@vista-digital/bem-class-builder';
import { observer } from 'mobx-react';
import { useContext } from 'react';
import { useI18n } from '../../../../context/occ/hooks/use-i18n';
import { TicketPickerContextInstance } from '../types/context';
import { getTicketTypeLongDescription } from '../utils/ticket-type-utils';
import { getTicketRedemptionDetails } from '../utils/ticket-utils';
const b = bemClassBuilder('v-ticket-picker-table-row-details');
/**
 * Renders the details of a ticket type.
 */
export const TicketPickerTableRowDetails = observer(props => {
    const i18n = useI18n();
    const { ticket, ticketType } = props;
    const { displayText } = useContext(TicketPickerContextInstance);
    const longDescription = getTicketTypeLongDescription(ticketType, i18n);
    const redemptionDetails = getTicketRedemptionDetails(displayText, ticket, i18n);
    return (_jsxs("div", Object.assign({ className: b.block() }, { children: [_jsx("span", Object.assign({ className: b.element('description') }, { children: i18n.translatable(ticketType.description) })), longDescription && _jsx("span", Object.assign({ className: b.element('long-description') }, { children: longDescription })), redemptionDetails && _jsx("span", Object.assign({ className: b.element('redemption-details') }, { children: redemptionDetails }))] })));
});
TicketPickerTableRowDetails.displayName = 'TicketPickerTableRowDetails';
